var JSON;
JSON || (JSON = {});
(function () {
  function p(c, a) {
    var e, k, w = f,
      h = a[c];
    h && "object" == typeof h && "function" == typeof h.toJSON && (h = h.toJSON(c));
    "function" == typeof t && (h = t.call(a, c, h));
    switch (typeof h) {
      case "string":
        return m(h);
      case "number":
        return isFinite(h) ? String(h) : "null";
      case "boolean":
      case "null":
        return String(h);
      case "object":
        if (!h) return "null";
        f += q;
        var r = [];
        if ("[object Array]" === Object.prototype.toString.apply(h)) {
          var n = h.length;
          for (e = 0; e < n; e += 1) r[e] = p(e, h) || "null";
          var l = 0 === r.length ? "[]" : f ? "[\n" + f + r.join(",\n" + f) + "\n" +
            w + "]" : "[" + r.join(",") + "]";
          f = w;
          return l
        }
        if (t && "object" == typeof t)
          for (n = t.length, e = 0; e < n; e += 1) "string" == typeof t[e] && (k = t[e], l = p(k, h), l && r.push(m(k) + (f ? ": " : ":") + l));
        else
          for (k in h) Object.prototype.hasOwnProperty.call(h, k) && (l = p(k, h), l && r.push(m(k) + (f ? ": " : ":") + l));
        l = 0 === r.length ? "{}" : f ? "{\n" + f + r.join(",\n" + f) + "\n" + w + "}" : "{" + r.join(",") + "}";
        f = w;
        return l
    }
  }

  function m(c) {
    a.lastIndex = 0;
    return a.test(c) ? '"' + c.replace(a, function (c) {
        var a = e[c];
        return "string" == typeof a ? a : "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4)
      }) +
      '"' : '"' + c + '"'
  }

  function c(c) {
    return 10 > c ? "0" + c : c
  }
  "use strict";
  "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function (a) {
    return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + c(this.getUTCMonth() + 1) + "-" + c(this.getUTCDate()) + "T" + c(this.getUTCHours()) + ":" + c(this.getUTCMinutes()) + ":" + c(this.getUTCSeconds()) + "Z" : null
  }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function (c) {
    return this.valueOf()
  });
  var h = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
    a = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
    f, q, e = {
      "\b": "\\b",
      "\t": "\\t",
      "\n": "\\n",
      "\f": "\\f",
      "\r": "\\r",
      '"': '\\"',
      "\\": "\\\\"
    },
    t;
  "function" != typeof JSON.stringify && (JSON.stringify = function (c, a, e) {
    var k;
    q = f = "";
    if ("number" == typeof e)
      for (k = 0; k < e; k += 1) q += " ";
    else "string" == typeof e && (q = e);
    t = a;
    if (!a || "function" == typeof a || "object" == typeof a && "number" == typeof a.length) return p("", {
      "": c
    });
    throw Error("JSON.stringify");
  });
  "function" !=
  typeof JSON.parse && (JSON.parse = function (c, a) {
    function e(c, f) {
      var k, h, l = c[f];
      if (l && "object" == typeof l)
        for (k in l) Object.prototype.hasOwnProperty.call(l, k) && (h = e(l, k), void 0 !== h ? l[k] = h : delete l[k]);
      return a.call(c, f, l)
    }
    c = String(c);
    h.lastIndex = 0;
    h.test(c) && (c = c.replace(h, function (c) {
      return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4)
    }));
    if (/^[\],:{}\s]*$/.test(c.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g,
        ""))) {
      var f = eval("(" + c + ")");
      return "function" == typeof a ? e({
        "": f
      }, "") : f
    }
    throw new SyntaxError("JSON.parse");
  })
})();

var SockJS = function () {
  var p = document,
    m = window,
    c = {},
    h = function () {};
  h.prototype.addEventListener = function (b, d) {
    this._listeners || (this._listeners = {});
    b in this._listeners || (this._listeners[b] = []);
    var g = this._listeners[b]; - 1 === c.arrIndexOf(g, d) && g.push(d)
  };
  h.prototype.removeEventListener = function (b, d) {
    if (this._listeners && b in this._listeners) {
      var g = this._listeners[b],
        a = c.arrIndexOf(g, d); - 1 !== a && (1 < g.length ? this._listeners[b] = g.slice(0, a).concat(g.slice(a + 1)) : delete this._listeners[b])
    }
  };
  h.prototype.dispatchEvent =
    function (b) {
      var d = b.type,
        g = Array.prototype.slice.call(arguments, 0);
      this["on" + d] && this["on" + d].apply(this, g);
      if (this._listeners && d in this._listeners)
        for (var c = 0; c < this._listeners[d].length; c++) this._listeners[d][c].apply(this, g)
    };
  var a = function (b, d) {
    this.type = b;
    if ("undefined" !== typeof d)
      for (var g in d) d.hasOwnProperty(g) && (this[g] = d[g])
  };
  a.prototype.toString = function () {
    var b = [],
      d;
    for (d in this)
      if (this.hasOwnProperty(d)) {
        var g = this[d];
        "function" === typeof g && (g = "[function]");
        b.push(d + "=" + g)
      }
    return "SimpleEvent(" +
      b.join(", ") + ")"
  };
  var f = function (b) {
    this._events = b || [];
    this._listeners = {}
  };
  f.prototype.emit = function (b) {
    this._verifyType(b);
    if (!this._nuked) {
      var d = Array.prototype.slice.call(arguments, 1);
      this["on" + b] && this["on" + b].apply(this, d);
      if (b in this._listeners)
        for (var g = 0; g < this._listeners[b].length; g++) this._listeners[b][g].apply(this, d)
    }
  };
  f.prototype.on = function (b, d) {
    this._verifyType(b);
    this._nuked || (b in this._listeners || (this._listeners[b] = []), this._listeners[b].push(d))
  };
  f.prototype._verifyType = function (b) {
    -1 ===
      c.arrIndexOf(this._events, b) && c.log("Event " + JSON.stringify(b) + " not listed " + JSON.stringify(this._events) + " in " + this)
  };
  f.prototype.nuke = function () {
    this._nuked = !0;
    for (var b = 0; b < this._events.length; b++) delete this[this._events[b]];
    this._listeners = {}
  };
  c.random_string = function (b, d) {
    d = d || 37;
    var g, c = [];
    for (g = 0; g < b; g++) c.push("abcdefghijklmnopqrstuvwxyz0123456789_".substr(Math.floor(Math.random() * d), 1));
    return c.join("")
  };
  c.random_number = function (b) {
    return Math.floor(Math.random() * b)
  };
  c.random_number_string =
    function (b) {
      var d = ("" + (b - 1)).length;
      return (Array(d + 1).join("0") + c.random_number(b)).slice(-d)
    };
  c.getOrigin = function (b) {
    return (b + "/").split("/").slice(0, 3).join("/")
  };
  c.isSameOriginUrl = function (b, d) {
    d || (d = m.location.href);
    return b.split("/").slice(0, 3).join("/") === d.split("/").slice(0, 3).join("/")
  };
  c.getParentDomain = function (b) {
    return /^[0-9.]*$/.test(b) || /^\[/.test(b) || !/[.]/.test(b) ? b : b.split(".").slice(1).join(".")
  };
  c.objectExtend = function (b, d) {
    for (var g in d) d.hasOwnProperty(g) && (b[g] = d[g]);
    return b
  };
  c.polluteGlobalNamespace = function () {
    "_jp" in m || (m._jp = {})
  };
  c.closeFrame = function (b, d) {
    return "c" + JSON.stringify([b, d])
  };
  c.userSetCode = function (b) {
    return 1E3 === b || 3E3 <= b && 4999 >= b
  };
  c.countRTO = function (b) {
    return 100 < b ? 3 * b : b + 200
  };
  c.log = function () {
    m.console && console.log && console.log.apply && console.log.apply(console, arguments)
  };
  c.bind = function (b, d) {
    return b.bind ? b.bind(d) : function () {
      return b.apply(d, arguments)
    }
  };
  c.flatUrl = function (b) {
    return -1 === b.indexOf("?") && -1 === b.indexOf("#")
  };
  c.amendUrl = function (b) {
    var d =
      p.location;
    if (!b) throw Error("Wrong url for SockJS");
    if (!c.flatUrl(b)) throw Error("Only basic urls are supported in SockJS");
    0 === b.indexOf("//") && (b = d.protocol + b);
    0 === b.indexOf("/") && (b = d.protocol + "//" + d.host + b);
    return b = b.replace(/[/]+$/, "")
  };
  c.arrIndexOf = function (b, d) {
    for (var g = 0; g < b.length; g++)
      if (b[g] === d) return g;
    return -1
  };
  c.arrSkip = function (b, d) {
    var g = c.arrIndexOf(b, d);
    return -1 === g ? b.slice() : b.slice(0, g).concat(b.slice(g + 1))
  };
  c.isArray = Array.isArray || function (b) {
    return 0 <= {}.toString.call(b).indexOf("Array")
  };
  c.delay = function (b, d) {
    "function" === typeof b && (d = b, b = 0);
    return setTimeout(d, b)
  };
  var q = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
    e = {
      "\x00": "\\u0000",
      "\u0001": "\\u0001",
      "\u0002": "\\u0002",
      "\u0003": "\\u0003",
      "\u0004": "\\u0004",
      "\u0005": "\\u0005",
      "\u0006": "\\u0006",
      "\u0007": "\\u0007",
      "\b": "\\b",
      "\t": "\\t",
      "\n": "\\n",
      "\x0B": "\\u000b",
      "\f": "\\f",
      "\r": "\\r",
      "\u000e": "\\u000e",
      "\u000f": "\\u000f",
      "\u0010": "\\u0010",
      "\u0011": "\\u0011",
      "\u0012": "\\u0012",
      "\u0013": "\\u0013",
      "\u0014": "\\u0014",
      "\u0015": "\\u0015",
      "\u0016": "\\u0016",
      "\u0017": "\\u0017",
      "\u0018": "\\u0018",
      "\u0019": "\\u0019",
      "\u001a": "\\u001a",
      "\u001b": "\\u001b",
      "\u001c": "\\u001c",
      "\u001d": "\\u001d",
      "\u001e": "\\u001e",
      "\u001f": "\\u001f",
      '"': '\\"',
      "\\": "\\\\",
      "\u007f": "\\u007f",
      "\u0080": "\\u0080",
      "\u0081": "\\u0081",
      "\u0082": "\\u0082",
      "\u0083": "\\u0083",
      "\u0084": "\\u0084",
      "\u0085": "\\u0085",
      "\u0086": "\\u0086",
      "\u0087": "\\u0087",
      "\u0088": "\\u0088",
      "\u0089": "\\u0089",
      "\u008a": "\\u008a",
      "\u008b": "\\u008b",
      "\u008c": "\\u008c",
      "\u008d": "\\u008d",
      "\u008e": "\\u008e",
      "\u008f": "\\u008f",
      "\u0090": "\\u0090",
      "\u0091": "\\u0091",
      "\u0092": "\\u0092",
      "\u0093": "\\u0093",
      "\u0094": "\\u0094",
      "\u0095": "\\u0095",
      "\u0096": "\\u0096",
      "\u0097": "\\u0097",
      "\u0098": "\\u0098",
      "\u0099": "\\u0099",
      "\u009a": "\\u009a",
      "\u009b": "\\u009b",
      "\u009c": "\\u009c",
      "\u009d": "\\u009d",
      "\u009e": "\\u009e",
      "\u009f": "\\u009f",
      "\u00ad": "\\u00ad",
      "\u0600": "\\u0600",
      "\u0601": "\\u0601",
      "\u0602": "\\u0602",
      "\u0603": "\\u0603",
      "\u0604": "\\u0604",
      "\u070f": "\\u070f",
      "\u17b4": "\\u17b4",
      "\u17b5": "\\u17b5",
      "\u200c": "\\u200c",
      "\u200d": "\\u200d",
      "\u200e": "\\u200e",
      "\u200f": "\\u200f",
      "\u2028": "\\u2028",
      "\u2029": "\\u2029",
      "\u202a": "\\u202a",
      "\u202b": "\\u202b",
      "\u202c": "\\u202c",
      "\u202d": "\\u202d",
      "\u202e": "\\u202e",
      "\u202f": "\\u202f",
      "\u2060": "\\u2060",
      "\u2061": "\\u2061",
      "\u2062": "\\u2062",
      "\u2063": "\\u2063",
      "\u2064": "\\u2064",
      "\u2065": "\\u2065",
      "\u2066": "\\u2066",
      "\u2067": "\\u2067",
      "\u2068": "\\u2068",
      "\u2069": "\\u2069",
      "\u206a": "\\u206a",
      "\u206b": "\\u206b",
      "\u206c": "\\u206c",
      "\u206d": "\\u206d",
      "\u206e": "\\u206e",
      "\u206f": "\\u206f",
      "\ufeff": "\\ufeff",
      "\ufff0": "\\ufff0",
      "\ufff1": "\\ufff1",
      "\ufff2": "\\ufff2",
      "\ufff3": "\\ufff3",
      "\ufff4": "\\ufff4",
      "\ufff5": "\\ufff5",
      "\ufff6": "\\ufff6",
      "\ufff7": "\\ufff7",
      "\ufff8": "\\ufff8",
      "\ufff9": "\\ufff9",
      "\ufffa": "\\ufffa",
      "\ufffb": "\\ufffb",
      "\ufffc": "\\ufffc",
      "\ufffd": "\\ufffd",
      "\ufffe": "\\ufffe",
      "\uffff": "\\uffff"
    },
    t = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g,
    k, w = JSON && JSON.stringify || function (b) {
      q.lastIndex = 0;
      q.test(b) && (b = b.replace(q, function (b) {
        return e[b]
      }));
      return '"' + b + '"'
    },
    C = function (b) {
      var d, g = {},
        c = [];
      for (d = 0; 65536 > d; d++) c.push(String.fromCharCode(d));
      b.lastIndex = 0;
      c.join("").replace(b, function (b) {
        g[b] = "\\u" + ("0000" + b.charCodeAt(0).toString(16)).slice(-4);
        return ""
      });
      b.lastIndex = 0;
      return g
    };
  c.quote = function (b) {
    b = w(b);
    t.lastIndex = 0;
    if (!t.test(b)) return b;
    k || (k = C(t));
    return b.replace(t, function (b) {
      return k[b]
    })
  };
  var F = "websocket xdr-streaming xhr-streaming iframe-eventsource iframe-htmlfile xdr-polling xhr-polling iframe-xhr-polling jsonp-polling".split(" ");
  c.probeProtocols = function () {
    for (var b = {}, d = 0; d < F.length; d++) {
      var g = F[d];
      b[g] = l[g] && l[g].enabled()
    }
    return b
  };
  c.detectProtocols = function (b, d, g) {
    var c = {},
      a = [];
    d || (d = F);
    for (var e = 0; e < d.length; e++) {
      var f = d[e];
      c[f] = b[f]
    }
    var k = function (b) {
      var d = b.shift();
      c[d] ? a.push(d) : 0 < b.length && k(b)
    };
    !1 !== g.websocket && k(["websocket"]);
    c["xhr-streaming"] && !g.null_origin ? a.push("xhr-streaming") : !c["xdr-streaming"] || g.cookie_needed || g.null_origin ? k(["iframe-eventsource", "iframe-htmlfile"]) : a.push("xdr-streaming");
    c["xhr-polling"] &&
      !g.null_origin ? a.push("xhr-polling") : !c["xdr-polling"] || g.cookie_needed || g.null_origin ? k(["iframe-xhr-polling", "jsonp-polling"]) : a.push("xdr-polling");
    return a
  };
  c.createHook = function () {
    var b = "a" + c.random_string(8);
    if (!("_sockjs_global" in m)) {
      var d = {};
      m._sockjs_global = function (b) {
        b in d || (d[b] = {
          id: b,
          del: function () {
            delete d[b]
          }
        });
        return d[b]
      }
    }
    return m._sockjs_global(b)
  };
  c.attachMessage = function (b) {
    c.attachEvent("message", b)
  };
  c.attachEvent = function (b, d) {
    "undefined" !== typeof m.addEventListener ? m.addEventListener(b,
      d, !1) : (p.attachEvent("on" + b, d), m.attachEvent("on" + b, d))
  };
  c.detachMessage = function (b) {
    c.detachEvent("message", b)
  };
  c.detachEvent = function (b, d) {
    "undefined" !== typeof m.addEventListener ? m.removeEventListener(b, d, !1) : (p.detachEvent("on" + b, d), m.detachEvent("on" + b, d))
  };
  var A = {},
    G = !1,
    r = function () {
      for (var b in A) A[b](), delete A[b]
    };
  c.attachEvent("unload", function () {
    G || (G = !0, r())
  });
  c.unload_add = function (b) {
    var d = c.random_string(8);
    A[d] = b;
    G && c.delay(r);
    return d
  };
  c.unload_del = function (b) {
    b in A && delete A[b]
  };
  c.createIframe = function (b, d) {
    var g = p.createElement("iframe"),
      a = function () {
        clearTimeout(k);
        try {
          g.onload = null
        } catch (I) {}
        g.onerror = null
      },
      e = function () {
        g && (a(), setTimeout(function () {
          g && g.parentNode.removeChild(g);
          g = null
        }, 0), c.unload_del(l))
      },
      f = function (b) {
        g && (e(), d(b))
      };
    g.src = b;
    g.style.display = "none";
    g.style.position = "absolute";
    g.onerror = function () {
      f("onerror")
    };
    g.onload = function () {
      clearTimeout(k);
      k = setTimeout(function () {
        f("onload timeout")
      }, 2E3)
    };
    p.body.appendChild(g);
    var k = setTimeout(function () {
        f("timeout")
      },
      15E3);
    var l = c.unload_add(e);
    return {
      post: function (b, d) {
        try {
          g && g.contentWindow && g.contentWindow.postMessage(b, d)
        } catch (T) {}
      },
      cleanup: e,
      loaded: a
    }
  };
  c.createHtmlfile = function (b, d) {
    var g = new ActiveXObject("htmlfile"),
      a = function () {
        clearTimeout(l)
      },
      e = function () {
        g && (a(), c.unload_del(h), k.parentNode.removeChild(k), k = g = null, CollectGarbage())
      };
    g.open();
    g.write('<html><script>document.domain="' + document.domain + '";\x3c/script></html>');
    g.close();
    g.parentWindow._jp = m._jp;
    var f = g.createElement("div");
    g.body.appendChild(f);
    var k = g.createElement("iframe");
    f.appendChild(k);
    k.src = b;
    var l = setTimeout(function () {
      g && (e(), d("timeout"))
    }, 15E3);
    var h = c.unload_add(e);
    return {
      post: function (b, d) {
        try {
          k && k.contentWindow && k.contentWindow.postMessage(b, d)
        } catch (Z) {}
      },
      cleanup: e,
      loaded: a
    }
  };
  var n = function () {};
  n.prototype = new f(["chunk", "finish"]);
  n.prototype._start = function (b, d, g, a) {
    var e = this;
    try {
      e.xhr = new XMLHttpRequest
    } catch (H) {}
    if (!e.xhr) try {
      e.xhr = new m.ActiveXObject("Microsoft.XMLHTTP")
    } catch (H) {}
    if (m.ActiveXObject || m.XDomainRequest) d +=
      (-1 === d.indexOf("?") ? "?" : "&") + "t=" + +new Date;
    e.unload_ref = c.unload_add(function () {
      e._cleanup(!0)
    });
    try {
      e.xhr.open(b, d, !0)
    } catch (H) {
      e.emit("finish", 0, "");
      e._cleanup();
      return
    }
    a && a.no_credentials || (e.xhr.withCredentials = "true");
    if (a && a.headers)
      for (var P in a.headers) e.xhr.setRequestHeader(P, a.headers[P]);
    e.xhr.onreadystatechange = function () {
      if (e.xhr) {
        var b = e.xhr;
        switch (b.readyState) {
          case 3:
            try {
              var d = b.status;
              var c = b.responseText
            } catch (S) {}
            1223 === d && (d = 204);
            c && 0 < c.length && e.emit("chunk", d, c);
            break;
          case 4:
            d =
              b.status, 1223 === d && (d = 204), e.emit("finish", d, b.responseText), e._cleanup(!1)
        }
      }
    };
    e.xhr.send(g)
  };
  n.prototype._cleanup = function (b) {
    if (this.xhr) {
      c.unload_del(this.unload_ref);
      this.xhr.onreadystatechange = function () {};
      if (b) try {
        this.xhr.abort()
      } catch (d) {}
      this.unload_ref = this.xhr = null
    }
  };
  n.prototype.close = function () {
    this.nuke();
    this._cleanup(!0)
  };
  (c.XHRCorsObject = function () {
    var b = this,
      d = arguments;
    c.delay(function () {
      b._start.apply(b, d)
    })
  }).prototype = new n;
  (c.XHRLocalObject = function (b, d, g) {
    var a = this;
    c.delay(function () {
      a._start(b,
        d, g, {
          no_credentials: !0
        })
    })
  }).prototype = new n;
  n = c.XDRObject = function (b, d, g) {
    var a = this;
    c.delay(function () {
      a._start(b, d, g)
    })
  };
  n.prototype = new f(["chunk", "finish"]);
  n.prototype._start = function (b, d, g) {
    var a = this,
      e = new XDomainRequest;
    d += (-1 === d.indexOf("?") ? "?" : "&") + "t=" + +new Date;
    var k = e.ontimeout = e.onerror = function () {
      a.emit("finish", 0, "");
      a._cleanup(!1)
    };
    e.onprogress = function () {
      a.emit("chunk", 200, e.responseText)
    };
    e.onload = function () {
      a.emit("finish", 200, e.responseText);
      a._cleanup(!1)
    };
    a.xdr = e;
    a.unload_ref =
      c.unload_add(function () {
        a._cleanup(!0)
      });
    try {
      a.xdr.open(b, d), a.xdr.send(g)
    } catch (H) {
      k()
    }
  };
  n.prototype._cleanup = function (b) {
    if (this.xdr) {
      c.unload_del(this.unload_ref);
      this.xdr.ontimeout = this.xdr.onerror = this.xdr.onprogress = this.xdr.onload = null;
      if (b) try {
        this.xdr.abort()
      } catch (d) {}
      this.unload_ref = this.xdr = null
    }
  };
  n.prototype.close = function () {
    this.nuke();
    this._cleanup(!0)
  };
  c.isXHRCorsCapable = function () {
    return m.XMLHttpRequest && "withCredentials" in new XMLHttpRequest ? 1 : m.XDomainRequest && p.domain ? 2 : u.enabled() ?
      3 : 4
  };
  var l = function (b, d, a) {
    if (this === m) return new l(b, d, a);
    var g = this;
    g._options = {
      devel: !1,
      debug: !1,
      protocols_whitelist: [],
      info: void 0,
      rtt: void 0
    };
    a && c.objectExtend(g._options, a);
    g._base_url = c.amendUrl(b);
    g._server = g._options.server || c.random_number_string(1E3);
    if (g._options.protocols_whitelist && g._options.protocols_whitelist.length) var e = g._options.protocols_whitelist;
    else(e = "string" === typeof d && 0 < d.length ? [d] : c.isArray(d) ? d : null) && g._debug('Deprecated API: Use "protocols_whitelist" option instead of supplying protocol list as a second parameter to SockJS constructor.');
    g._protocols = [];
    g.protocol = null;
    g.readyState = l.CONNECTING;
    g._ir = U(g._base_url);
    g._ir.onfinish = function (b, d) {
      g._ir = null;
      b ? (g._options.info && (b = c.objectExtend(b, g._options.info)), g._options.rtt && (d = g._options.rtt), g._applyInfo(b, d, e), g._didClose()) : g._didClose(1002, "Can't connect to server", !0)
    }
  };
  l.prototype = new h;
  l.version = "0.3.4";
  l.CONNECTING = 0;
  l.OPEN = 1;
  l.CLOSING = 2;
  l.CLOSED = 3;
  l.prototype._debug = function () {
    this._options.debug && c.log.apply(c, arguments)
  };
  l.prototype._dispatchOpen = function () {
    this.readyState ===
      l.CONNECTING ? (this._transport_tref && (clearTimeout(this._transport_tref), this._transport_tref = null), this.readyState = l.OPEN, this.dispatchEvent(new a("open"))) : this._didClose(1006, "Server lost session")
  };
  l.prototype._dispatchMessage = function (b) {
    this.readyState === l.OPEN && this.dispatchEvent(new a("message", {
      data: b
    }))
  };
  l.prototype._dispatchHeartbeat = function (b) {
    this.readyState === l.OPEN && this.dispatchEvent(new a("heartbeat", {}))
  };
  l.prototype._didClose = function (b, d, g) {
    var e = this;
    if (e.readyState !== l.CONNECTING &&
      e.readyState !== l.OPEN && e.readyState !== l.CLOSING) throw Error("INVALID_STATE_ERR");
    e._ir && (e._ir.nuke(), e._ir = null);
    e._transport && (e._transport.doCleanup(), e._transport = null);
    var k = new a("close", {
      code: b,
      reason: d,
      wasClean: c.userSetCode(b)
    });
    if (!c.userSetCode(b) && e.readyState === l.CONNECTING && !g) {
      if (e._try_next_protocol(k)) return;
      k = new a("close", {
        code: 2E3,
        reason: "All transports failed",
        wasClean: !1,
        last_event: k
      })
    }
    e.readyState = l.CLOSED;
    c.delay(function () {
      e.dispatchEvent(k)
    })
  };
  l.prototype._didMessage = function (b) {
    switch (b.slice(0,
      1)) {
      case "o":
        this._dispatchOpen();
        break;
      case "a":
        b = JSON.parse(b.slice(1) || "[]");
        for (var d = 0; d < b.length; d++) this._dispatchMessage(b[d]);
        break;
      case "m":
        b = JSON.parse(b.slice(1) || "null");
        this._dispatchMessage(b);
        break;
      case "c":
        b = JSON.parse(b.slice(1) || "[]");
        this._didClose(b[0], b[1]);
        break;
      case "h":
        this._dispatchHeartbeat()
    }
  };
  l.prototype._try_next_protocol = function (b) {
    var d = this;
    d.protocol && (d._debug("Closed transport:", d.protocol, "" + b), d.protocol = null);
    d._transport_tref && (clearTimeout(d._transport_tref),
      d._transport_tref = null);
    for (;;) {
      b = d.protocol = d._protocols.shift();
      if (!b) return !1;
      if (l[b] && !0 === l[b].need_body && (!p.body || "undefined" !== typeof p.readyState && "complete" !== p.readyState)) return d._protocols.unshift(b), d.protocol = "waiting-for-load", c.attachEvent("load", function () {
        d._try_next_protocol()
      }), !0;
      if (l[b] && l[b].enabled(d._options)) {
        d._transport_tref = c.delay((d._options.rto || 0) * (l[b].roundTrips || 1) || 5E3, function () {
          d.readyState === l.CONNECTING && d._didClose(2007, "Transport timeouted")
        });
        var g = c.random_string(8);
        g = d._base_url + "/" + d._server + "/" + g;
        d._debug("Opening transport:", b, " url:" + g, " RTO:" + d._options.rto);
        d._transport = new l[b](d, g, d._base_url);
        return !0
      }
      d._debug("Skipping transport:", b)
    }
  };
  l.prototype.close = function (b, d) {
    if (b && !c.userSetCode(b)) throw Error("INVALID_ACCESS_ERR");
    if (this.readyState !== l.CONNECTING && this.readyState !== l.OPEN) return !1;
    this.readyState = l.CLOSING;
    this._didClose(b || 1E3, d || "Normal closure");
    return !0
  };
  l.prototype.send = function (b) {
    if (this.readyState === l.CONNECTING) throw Error("INVALID_STATE_ERR");
    this.readyState === l.OPEN && this._transport.doSend(c.quote("" + b));
    return !0
  };
  l.prototype._applyInfo = function (b, d, g) {
    this._options.info = b;
    this._options.rtt = d;
    this._options.rto = c.countRTO(d);
    this._options.info.null_origin = !p.domain;
    d = c.probeProtocols();
    this._protocols = c.detectProtocols(d, g, b)
  };
  n = l.websocket = function (b, d) {
    var g = this,
      a = d + "/websocket";
    a = "https" === a.slice(0, 5) ? "wss" + a.slice(5) : "ws" + a.slice(4);
    g.ri = b;
    g.url = a;
    g.ws = new(m.WebSocket || m.MozWebSocket)(g.url);
    g.ws.onmessage = function (b) {
      g.ri._didMessage(b.data)
    };
    g.unload_ref = c.unload_add(function () {
      g.ws.close()
    });
    g.ws.onclose = function () {
      g.ri._didMessage(c.closeFrame(1006, "WebSocket connection broken"))
    }
  };
  n.prototype.doSend = function (b) {
    this.ws.send("[" + b + "]")
  };
  n.prototype.doCleanup = function () {
    var b = this.ws;
    b && (b.onmessage = b.onclose = null, b.close(), c.unload_del(this.unload_ref), this.unload_ref = this.ri = this.ws = null)
  };
  n.enabled = function () {
    return !(!m.WebSocket && !m.MozWebSocket)
  };
  n.roundTrips = 2;
  var v = function () {};
  v.prototype.send_constructor = function (b) {
    this.send_buffer = [];
    this.sender = b
  };
  v.prototype.doSend = function (b) {
    this.send_buffer.push(b);
    this.send_stop || this.send_schedule()
  };
  v.prototype.send_schedule_wait = function () {
    var b = this;
    b.send_stop = function () {
      b.send_stop = null;
      clearTimeout(d)
    };
    var d = c.delay(25, function () {
      b.send_stop = null;
      b.send_schedule()
    })
  };
  v.prototype.send_schedule = function () {
    var b = this;
    if (0 < b.send_buffer.length) {
      var d = "[" + b.send_buffer.join(",") + "]";
      b.send_stop = b.sender(b.trans_url, d, function (d, a) {
        b.send_stop = null;
        !1 === d ? b.ri._didClose(1006, "Sending error " +
          a) : b.send_schedule_wait()
      });
      b.send_buffer = []
    }
  };
  v.prototype.send_destructor = function () {
    this._send_stop && this._send_stop();
    this._send_stop = null
  };
  var V = function (b, d, g) {
      if (!("_send_form" in this)) {
        var a = this._send_form = p.createElement("form");
        var e = this._send_area = p.createElement("textarea");
        e.name = "d";
        a.style.display = "none";
        a.style.position = "absolute";
        a.method = "POST";
        a.enctype = "application/x-www-form-urlencoded";
        a.acceptCharset = "UTF-8";
        a.appendChild(e);
        p.body.appendChild(a)
      }
      a = this._send_form;
      e = this._send_area;
      var k = "a" + c.random_string(8);
      a.target = k;
      a.action = b + "/jsonp_send?i=" + k;
      try {
        var f = p.createElement('<iframe name="' + k + '">')
      } catch (I) {
        f = p.createElement("iframe"), f.name = k
      }
      f.id = k;
      a.appendChild(f);
      f.style.display = "none";
      try {
        e.value = d
      } catch (I) {
        c.log("Your browser is seriously broken. Go home! " + I.message)
      }
      a.submit();
      var l = function (b) {
        f.onerror && (f.onreadystatechange = f.onerror = f.onload = null, c.delay(500, function () {
          f.parentNode.removeChild(f);
          f = null
        }), e.value = "", g(!0))
      };
      f.onerror = f.onload = l;
      f.onreadystatechange =
        function (b) {
          "complete" == f.readyState && l()
        };
      return l
    },
    W = function (b) {
      return function (d, a, c) {
        (new b("POST", d + "/xhr_send", a)).onfinish = function (b, d) {
          c(200 === b || 204 === b, "http status " + b)
        };
        return function (b) {
          c(!1, b)
        }
      }
    },
    D = function (b, d) {
      var a = p.createElement("script"),
        e = function (b) {
          l && (l.parentNode.removeChild(l), l = null);
          a && (clearTimeout(h), a.parentNode.removeChild(a), a = a.onreadystatechange = a.onerror = a.onload = a.onclick = null, d(b), d = null)
        },
        k = !1,
        f = null;
      a.id = "a" + c.random_string(8);
      a.src = b;
      a.type = "text/javascript";
      a.charset = "UTF-8";
      a.onerror = function (b) {
        f || (f = setTimeout(function () {
          k || e(c.closeFrame(1006, "JSONP script loaded abnormally (onerror)"))
        }, 1E3))
      };
      a.onload = function (b) {
        e(c.closeFrame(1006, "JSONP script loaded abnormally (onload)"))
      };
      a.onreadystatechange = function (b) {
        if (/loaded|closed/.test(a.readyState)) {
          if (a && a.htmlFor && a.onclick) {
            k = !0;
            try {
              a.onclick()
            } catch (T) {}
          }
          a && e(c.closeFrame(1006, "JSONP script loaded abnormally (onreadystatechange)"))
        }
      };
      if ("undefined" === typeof a.async && p.attachEvent)
        if (/opera/i.test(navigator.userAgent)) {
          var l =
            p.createElement("script");
          l.text = "try{var a = document.getElementById('" + a.id + "'); if(a)a.onerror();}catch(x){};";
          a.async = l.async = !1
        } else {
          try {
            a.htmlFor = a.id, a.event = "onclick"
          } catch (S) {}
          a.async = !0
        }
      "undefined" !== typeof a.async && (a.async = !0);
      var h = setTimeout(function () {
        e(c.closeFrame(1006, "JSONP script loaded abnormally (timeout)"))
      }, 35E3);
      var t = p.getElementsByTagName("head")[0];
      t.insertBefore(a, t.firstChild);
      l && t.insertBefore(l, t.firstChild);
      return e
    };
  n = l["jsonp-polling"] = function (b, d) {
    c.polluteGlobalNamespace();
    this.ri = b;
    this.trans_url = d;
    this.send_constructor(V);
    this._schedule_recv()
  };
  n.prototype = new v;
  n.prototype._schedule_recv = function () {
    var b = this;
    b._recv_stop = X(b.trans_url + "/jsonp", D, function (d) {
      b._recv_stop = null;
      d && (b._is_closing || b.ri._didMessage(d));
      b._is_closing || b._schedule_recv()
    })
  };
  n.enabled = function () {
    return !0
  };
  n.need_body = !0;
  n.prototype.doCleanup = function () {
    this._is_closing = !0;
    this._recv_stop && this._recv_stop();
    this.ri = this._recv_stop = null;
    this.send_destructor()
  };
  var X = function (b, d, a) {
    var e =
      "a" + c.random_string(6);
    b = b + "?c=" + escape("_jp." + e);
    var g = 0;
    d = d(b, function (b) {
      switch (g) {
        case 0:
          delete m._jp[e];
          a(b);
          break;
        case 1:
          a(b);
          g = 2;
          break;
        case 2:
          delete m._jp[e]
      }
    });
    m._jp[e] = d;
    return function () {
      m._jp[e] && (g = 1, m._jp[e](c.closeFrame(1E3, "JSONP user aborted read")))
    }
  };
  n = function () {};
  n.prototype = new v;
  n.prototype.run = function (b, d, a, c, e) {
    this.ri = b;
    this.trans_url = d;
    this.send_constructor(W(e));
    this.poll = new J(b, c, d + a, e)
  };
  n.prototype.doCleanup = function () {
    this.poll && (this.poll.abort(), this.poll = null)
  };
  var y = l["xhr-streaming"] = function (b, a) {
    this.run(b, a, "/xhr_streaming", z, c.XHRCorsObject)
  };
  y.prototype = new n;
  y.enabled = function () {
    return m.XMLHttpRequest && "withCredentials" in new XMLHttpRequest && !/opera/i.test(navigator.userAgent)
  };
  y.roundTrips = 2;
  y.need_body = !0;
  v = l["xdr-streaming"] = function (b, a) {
    this.run(b, a, "/xhr_streaming", z, c.XDRObject)
  };
  v.prototype = new n;
  v.enabled = function () {
    return !!m.XDomainRequest
  };
  v.roundTrips = 2;
  var K = l["xhr-polling"] = function (b, a) {
    this.run(b, a, "/xhr", z, c.XHRCorsObject)
  };
  K.prototype =
    new n;
  K.enabled = y.enabled;
  K.roundTrips = 2;
  y = l["xdr-polling"] = function (b, a) {
    this.run(b, a, "/xhr", z, c.XDRObject)
  };
  y.prototype = new n;
  y.enabled = v.enabled;
  y.roundTrips = 2;
  var u = function () {};
  u.prototype.i_constructor = function (b, a, e) {
    var d = this;
    d.ri = b;
    d.origin = c.getOrigin(e);
    d.base_url = e;
    d.trans_url = a;
    b = e + "/iframe.html";
    d.ri._options.devel && (b += "?t=" + +new Date);
    d.window_id = c.random_string(8);
    b += "#" + d.window_id;
    d.iframeObj = c.createIframe(b, function (b) {
      d.ri._didClose(1006, "Unable to load an iframe (" + b + ")")
    });
    d.onmessage_cb = c.bind(d.onmessage, d);
    c.attachMessage(d.onmessage_cb)
  };
  u.prototype.doCleanup = function () {
    if (this.iframeObj) {
      c.detachMessage(this.onmessage_cb);
      try {
        this.iframeObj.iframe.contentWindow && this.postMessage("c")
      } catch (b) {}
      this.iframeObj.cleanup();
      this.onmessage_cb = this.iframeObj = null
    }
  };
  u.prototype.onmessage = function (b) {
    if (b.origin === this.origin) {
      var a = b.data.slice(0, 8),
        c = b.data.slice(8, 9);
      b = b.data.slice(9);
      if (a === this.window_id) switch (c) {
        case "s":
          this.iframeObj.loaded();
          this.postMessage("s",
            JSON.stringify([l.version, this.protocol, this.trans_url, this.base_url]));
          break;
        case "t":
          this.ri._didMessage(b)
      }
    }
  };
  u.prototype.postMessage = function (b, a) {
    this.iframeObj.post(this.window_id + b + (a || ""), this.origin)
  };
  u.prototype.doSend = function (b) {
    this.postMessage("m", b)
  };
  u.enabled = function () {
    var b = navigator && navigator.userAgent && -1 !== navigator.userAgent.indexOf("Konqueror");
    return ("function" === typeof m.postMessage || "object" === typeof m.postMessage) && !b
  };
  var L, M = function (b, a) {
      parent !== m ? parent.postMessage(L +
        b + (a || ""), "*") : c.log("Can't postMessage, no parent window.", b, a)
    },
    x = function () {};
  x.prototype._didClose = function (b, a) {
    M("t", c.closeFrame(b, a))
  };
  x.prototype._didMessage = function (b) {
    M("t", b)
  };
  x.prototype._doSend = function (b) {
    this._transport.doSend(b)
  };
  x.prototype._doCleanup = function () {
    this._transport.doCleanup()
  };
  c.parent_origin = void 0;
  l.bootstrap_iframe = function () {
    var b;
    L = p.location.hash.slice(1);
    c.attachMessage(function (a) {
      if (a.source === parent && ("undefined" === typeof c.parent_origin && (c.parent_origin =
          a.origin), a.origin === c.parent_origin)) {
        var d = a.data.slice(0, 8),
          e = a.data.slice(8, 9);
        a = a.data.slice(9);
        if (d === L) switch (e) {
          case "s":
            var k = JSON.parse(a);
            d = k[0];
            e = k[1];
            a = k[2];
            k = k[3];
            d !== l.version && c.log('Incompatibile SockJS! Main site uses: "' + d + '", the iframe: "' + l.version + '".');
            if (!c.flatUrl(a) || !c.flatUrl(k)) {
              c.log("Only basic urls are supported in SockJS");
              break
            }
            if (!c.isSameOriginUrl(a) || !c.isSameOriginUrl(k)) {
              c.log("Can't connect to different domain from within an iframe. (" + JSON.stringify([m.location.href,
                a, k
              ]) + ")");
              break
            }
            b = new x;
            b._transport = new x[e](b, a, k);
            break;
          case "m":
            b._doSend(a);
            break;
          case "c":
            b && b._doCleanup(), b = null
        }
      }
    });
    M("s")
  };
  var B = function (b, a) {
    var d = this;
    c.delay(function () {
      d.doXhr(b, a)
    })
  };
  B.prototype = new f(["finish"]);
  B.prototype.doXhr = function (b, a) {
    var d = this,
      e = (new Date).getTime(),
      k = new a("GET", b + "/info"),
      f = c.delay(8E3, function () {
        k.ontimeout()
      });
    k.onfinish = function (b, a) {
      clearTimeout(f);
      f = null;
      if (200 === b) {
        var c = (new Date).getTime() - e,
          g = JSON.parse(a);
        "object" !== typeof g && (g = {});
        d.emit("finish",
          g, c)
      } else d.emit("finish")
    };
    k.ontimeout = function () {
      k.close();
      d.emit("finish")
    }
  };
  var Q = function (b) {
    var a = this,
      e = function () {
        var d = new u;
        d.protocol = "w-iframe-info-receiver";
        var c = function (b) {
          "string" === typeof b && "m" === b.substr(0, 1) ? (b = JSON.parse(b.substr(1)), a.emit("finish", b[0], b[1])) : a.emit("finish");
          d.doCleanup();
          d = null
        };
        d.i_constructor({
          _options: {},
          _didClose: c,
          _didMessage: c
        }, b, b)
      };
    p.body ? e() : c.attachEvent("load", e)
  };
  Q.prototype = new f(["finish"]);
  var R = function () {
    var b = this;
    c.delay(function () {
      b.emit("finish", {}, 2E3)
    })
  };
  R.prototype = new f(["finish"]);
  var U = function (b) {
    if (c.isSameOriginUrl(b)) return new B(b, c.XHRLocalObject);
    switch (c.isXHRCorsCapable()) {
      case 1:
        return new B(b, c.XHRLocalObject);
      case 2:
        return new B(b, c.XDRObject);
      case 3:
        return new Q(b);
      default:
        return new R
    }
  };
  (x["w-iframe-info-receiver"] = function (b, a, e) {
    (new B(e, c.XHRLocalObject)).onfinish = function (a, d) {
      b._didMessage("m" + JSON.stringify([a, d]));
      b._didClose()
    }
  }).prototype.doCleanup = function () {};
  f = l["iframe-eventsource"] = function () {
    this.protocol =
      "w-iframe-eventsource";
    this.i_constructor.apply(this, arguments)
  };
  f.prototype = new u;
  f.enabled = function () {
    return "EventSource" in m && u.enabled()
  };
  f.need_body = !0;
  f.roundTrips = 3;
  (x["w-iframe-eventsource"] = function (b, a) {
    this.run(b, a, "/eventsource", N, c.XHRLocalObject)
  }).prototype = new n;
  f = l["iframe-xhr-polling"] = function () {
    this.protocol = "w-iframe-xhr-polling";
    this.i_constructor.apply(this, arguments)
  };
  f.prototype = new u;
  f.enabled = function () {
    return m.XMLHttpRequest && u.enabled()
  };
  f.need_body = !0;
  f.roundTrips = 3;
  (x["w-iframe-xhr-polling"] = function (b, a) {
    this.run(b, a, "/xhr", z, c.XHRLocalObject)
  }).prototype = new n;
  f = l["iframe-htmlfile"] = function () {
    this.protocol = "w-iframe-htmlfile";
    this.i_constructor.apply(this, arguments)
  };
  f.prototype = new u;
  f.enabled = function () {
    return u.enabled()
  };
  f.need_body = !0;
  f.roundTrips = 3;
  (x["w-iframe-htmlfile"] = function (b, a) {
    this.run(b, a, "/htmlfile", O, c.XHRLocalObject)
  }).prototype = new n;
  var J = function (b, a, c, e) {
    this.ri = b;
    this.Receiver = a;
    this.recv_url = c;
    this.AjaxObject = e;
    this._scheduleRecv()
  };
  J.prototype._scheduleRecv = function () {
    var b = this,
      a = b.poll = new b.Receiver(b.recv_url, b.AjaxObject);
    a.onmessage = function (a) {
      b.ri._didMessage(a.data)
    };
    a.onclose = function (d) {
      b.poll = a = a.onmessage = a.onclose = null;
      b.poll_is_closing || ("permanent" === d.reason ? b.ri._didClose(1006, "Polling error (" + d.reason + ")") : b._scheduleRecv())
    }
  };
  J.prototype.abort = function () {
    this.poll_is_closing = !0;
    this.poll && this.poll.abort()
  };
  var N = function (b) {
    var d = this,
      e = new EventSource(b);
    e.onmessage = function (b) {
      d.dispatchEvent(new a("message", {
        data: unescape(b.data)
      }))
    };
    d.es_close = e.onerror = function (b, g) {
      var k = g ? "user" : 2 !== e.readyState ? "network" : "permanent";
      d.es_close = e.onmessage = e.onerror = null;
      e.close();
      e = null;
      c.delay(200, function () {
        d.dispatchEvent(new a("close", {
          reason: k
        }))
      })
    }
  };
  N.prototype = new h;
  N.prototype.abort = function () {
    this.es_close && this.es_close({}, !0)
  };
  var E, O = function (b) {
    var d = this;
    c.polluteGlobalNamespace();
    d.id = "a" + c.random_string(6, 26);
    b += (-1 === b.indexOf("?") ? "?" : "&") + "c=" + escape("_jp." + d.id);
    if (void 0 === E)
      if ("ActiveXObject" in
        m) try {
        E = !!new ActiveXObject("htmlfile")
      } catch (Y) {} else E = !1;
    var e = E ? c.createHtmlfile : c.createIframe;
    m._jp[d.id] = {
      start: function () {
        k.loaded()
      },
      message: function (b) {
        d.dispatchEvent(new a("message", {
          data: b
        }))
      },
      stop: function () {
        d.iframe_close({}, "network")
      }
    };
    d.iframe_close = function (b, c) {
      k.cleanup();
      d.iframe_close = k = null;
      delete m._jp[d.id];
      d.dispatchEvent(new a("close", {
        reason: c
      }))
    };
    var k = e(b, function (b) {
      d.iframe_close({}, "permanent")
    })
  };
  O.prototype = new h;
  O.prototype.abort = function () {
    this.iframe_close &&
      this.iframe_close({}, "user")
  };
  var z = function (b, d) {
    var c = this,
      e = 0;
    c.xo = new d("POST", b, null);
    c.xo.onchunk = function (b, d) {
      if (200 === b)
        for (;;) {
          var g = d.slice(e),
            k = g.indexOf("\n");
          if (-1 === k) break;
          e += k + 1;
          g = g.slice(0, k);
          c.dispatchEvent(new a("message", {
            data: g
          }))
        }
    };
    c.xo.onfinish = function (b, d) {
      c.xo.onchunk(b, d);
      c.xo = null;
      c.dispatchEvent(new a("close", {
        reason: 200 === b ? "network" : "permanent"
      }))
    }
  };
  z.prototype = new h;
  z.prototype.abort = function () {
    this.xo && (this.xo.close(), this.dispatchEvent(new a("close", {
        reason: "user"
      })),
      this.xo = null)
  };
  l.getUtils = function () {
    return c
  };
  l.getIframeTransport = function () {
    return u
  };
  return l
}();
"_sockjs_onload" in window && setTimeout(_sockjs_onload, 1);
"function" === typeof define && define.amd && define("sockjs", [], function () {
  return SockJS
});
(function () {
  var p = {}.hasOwnProperty,
    m = [].slice;
  var c = function () {
    function a(a, c, k) {
      this.command = a;
      this.headers = null != c ? c : {};
      this.body = null != k ? k : ""
    }
    a.prototype.toString = function () {
      var c, f;
      var k = [this.command];
      (f = !1 === this.headers["content-length"] ? !0 : !1) && delete this.headers["content-length"];
      var h = this.headers;
      for (c in h)
        if (p.call(h, c)) {
          var m = h[c];
          k.push("" + c + ":" + m)
        }
      this.body && !f && k.push("content-length:" + a.sizeOfUTF8(this.body));
      k.push("\n" + this.body);
      return k.join("\n")
    };
    a.sizeOfUTF8 = function (a) {
      return a ?
        encodeURI(a).match(/%..|./g).length : 0
    };
    var c = function (c) {
      var e;
      var k = c.search(/\n\n/);
      var f = c.substring(0, k).split("\n");
      var h = f.shift();
      var m = {};
      var q = function (a) {
        return a.replace(/^\s+|\s+$/g, "")
      };
      var p = f.reverse();
      var r = 0;
      for (e = p.length; r < e; r++) {
        var n = p[r];
        f = n.indexOf(":");
        m[q(n.substring(0, f))] = q(n.substring(f + 1))
      }
      q = "";
      k += 2;
      if (m["content-length"]) q = parseInt(m["content-length"]), q = ("" + c).substring(k, k + q);
      else
        for (r = null, r = f = k, n = c.length; k <= n ? f < n : f > n; r = k <= n ? ++f : --f) {
          r = c.charAt(r);
          if ("\x00" === r) break;
          q += r
        }
      return new a(h, m, q)
    };
    a.unmarshall = function (a) {
      var e = a.split(/\x00\n*/);
      a = {
        frames: [],
        partial: ""
      };
      var k;
      var f = e.slice(0, -1);
      var h = [];
      var m = 0;
      for (k = f.length; m < k; m++) {
        var q = f[m];
        h.push(c(q))
      }
      a.frames = h;
      q = e.slice(-1)[0];
      "\n" === q || -1 !== q.search(/\x00\n*$/) ? a.frames.push(c(q)) : a.partial = q;
      return a
    };
    a.marshall = function (c, f, k) {
      return (new a(c, f, k)).toString() + "\x00"
    };
    return a
  }();
  var h = function () {
    function f(a) {
      this.ws = a;
      this.ws.binaryType = "arraybuffer";
      this.counter = 0;
      this.connected = !1;
      this.heartbeat = {
        outgoing: 1E4,
        incoming: 1E4
      };
      this.maxWebSocketFrameSize = 16384;
      this.subscriptions = {};
      this.partialData = ""
    }
    f.prototype.debug = function (a) {
      var c;
      return "undefined" !== typeof window && null !== window ? null != (c = window.console) ? c.log(a) : void 0 : void 0
    };
    var h = function () {
      return Date.now ? Date.now() : (new Date).valueOf
    };
    f.prototype._transmit = function (a, f, k) {
      a = c.marshall(a, f, k);
      for ("function" === typeof this.debug && this.debug(">>> " + a);;)
        if (a.length > this.maxWebSocketFrameSize) this.ws.send(a.substring(0, this.maxWebSocketFrameSize)), a =
          a.substring(this.maxWebSocketFrameSize), "function" === typeof this.debug && this.debug("remaining = " + a.length);
        else return this.ws.send(a)
    };
    f.prototype._setupHeartbeat = function (c) {
      var e, k;
      if ((e = c.version) === a.VERSIONS.V1_1 || e === a.VERSIONS.V1_2) {
        var f = function () {
          var a;
          var e = c["heart-beat"].split(",");
          var f = [];
          var h = 0;
          for (a = e.length; h < a; h++) k = e[h], f.push(parseInt(k));
          return f
        }();
        e = f[0];
        f = f[1];
        if (0 !== this.heartbeat.outgoing && 0 !== f) {
          var m = Math.max(this.heartbeat.outgoing, f);
          "function" === typeof this.debug &&
            this.debug("send PING every " + m + "ms");
          this.pinger = a.setInterval(m, function (a) {
            return function () {
              a.ws.send("\n");
              return "function" === typeof a.debug ? a.debug(">>> PING") : void 0
            }
          }(this))
        }
        if (0 !== this.heartbeat.incoming && 0 !== e) return m = Math.max(this.heartbeat.incoming, e), "function" === typeof this.debug && this.debug("check PONG every " + m + "ms"), this.ponger = a.setInterval(m, function (a) {
          return function () {
            var c = h() - a.serverActivity;
            if (c > 2 * m) return "function" === typeof a.debug && a.debug("did not receive server activity for the last " +
              c + "ms"), a.ws.close()
          }
        }(this))
      }
    };
    f.prototype._parseConnect = function () {
      var a = 1 <= arguments.length ? m.call(arguments, 0) : [];
      var c = {};
      switch (a.length) {
        case 2:
          c = a[0];
          var k = a[1];
          break;
        case 3:
          if (a[1] instanceof Function) {
            c = a[0];
            k = a[1];
            var f = a[2]
          } else c.login = a[0], c.passcode = a[1], k = a[2];
          break;
        case 4:
          c.login = a[0];
          c.passcode = a[1];
          k = a[2];
          f = a[3];
          break;
        default:
          c.login = a[0], c.passcode = a[1], k = a[2], f = a[3], c.host = a[4]
      }
      return [c, k, f]
    };
    f.prototype.connect = function () {
      var e = 1 <= arguments.length ? m.call(arguments, 0) : [];
      e = this._parseConnect.apply(this,
        e);
      var f = e[0];
      this.connectCallback = e[1];
      var k = e[2];
      "function" === typeof this.debug && this.debug("Opening Web Socket...");
      this.ws.onmessage = function (a) {
        return function (e) {
          var f, m, q, p;
          e = "undefined" !== typeof ArrayBuffer && e.data instanceof ArrayBuffer ? (f = new Uint8Array(e.data), "function" === typeof a.debug ? a.debug("--- got data length: " + f.length) : void 0, function () {
            var a;
            var c = [];
            var e = 0;
            for (a = f.length; e < a; e++) m = f[e], c.push(String.fromCharCode(m));
            return c
          }().join("")) : e.data;
          a.serverActivity = h();
          if ("\n" ===
            e) "function" === typeof a.debug && a.debug("<<< PONG");
          else {
            "function" === typeof a.debug && a.debug("<<< " + e);
            e = c.unmarshall(a.partialData + e);
            a.partialData = e.partial;
            var n = e.frames;
            var l = [];
            var t = 0;
            for (p = n.length; t < p; t++) switch (e = n[t], e.command) {
              case "CONNECTED":
                "function" === typeof a.debug && a.debug("connected to server " + e.headers.server);
                a.connected = !0;
                a._setupHeartbeat(e.headers);
                l.push("function" === typeof a.connectCallback ? a.connectCallback(e) : void 0);
                break;
              case "MESSAGE":
                var w = e.headers.subscription;
                if (q = a.subscriptions[w] || a.onreceive) {
                  var C = a;
                  var D = e.headers["message-id"];
                  e.ack = function (a) {
                    null == a && (a = {});
                    return C.ack(D, w, a)
                  };
                  e.nack = function (a) {
                    null == a && (a = {});
                    return C.nack(D, w, a)
                  };
                  l.push(q(e))
                } else l.push("function" === typeof a.debug ? a.debug("Unhandled received MESSAGE: " + e) : void 0);
                break;
              case "RECEIPT":
                l.push("function" === typeof a.onreceipt ? a.onreceipt(e) : void 0);
                break;
              case "ERROR":
                l.push("function" === typeof k ? k(e) : void 0);
                break;
              default:
                l.push("function" === typeof a.debug ? a.debug("Unhandled frame: " +
                  e) : void 0)
            }
            return l
          }
        }
      }(this);
      this.ws.onclose = function (a) {
        return function () {
          var c = "Whoops! Lost connection to " + a.ws.url;
          "function" === typeof a.debug && a.debug(c);
          a._cleanUp();
          return "function" === typeof k ? k(c) : void 0
        }
      }(this);
      return this.ws.onopen = function (c) {
        return function () {
          "function" === typeof c.debug && c.debug("Web Socket Opened...");
          f["accept-version"] = a.VERSIONS.supportedVersions();
          f["heart-beat"] = [c.heartbeat.outgoing, c.heartbeat.incoming].join();
          return c._transmit("CONNECT", f)
        }
      }(this)
    };
    f.prototype.disconnect =
      function (a, c) {
        null == c && (c = {});
        this._transmit("DISCONNECT", c);
        this.ws.onclose = null;
        this.ws.close();
        this._cleanUp();
        return "function" === typeof a ? a() : void 0
      };
    f.prototype._cleanUp = function () {
      this.connected = !1;
      this.pinger && a.clearInterval(this.pinger);
      if (this.ponger) return a.clearInterval(this.ponger)
    };
    f.prototype.send = function (a, c, f) {
      null == c && (c = {});
      null == f && (f = "");
      c.destination = a;
      return this._transmit("SEND", c, f)
    };
    f.prototype.subscribe = function (a, c, f) {
      null == f && (f = {});
      f.id || (f.id = "sub-" + this.counter++);
      f.destination = a;
      this.subscriptions[f.id] = c;
      this._transmit("SUBSCRIBE", f);
      var e = this;
      return {
        id: f.id,
        unsubscribe: function () {
          return e.unsubscribe(f.id)
        }
      }
    };
    f.prototype.unsubscribe = function (a) {
      delete this.subscriptions[a];
      return this._transmit("UNSUBSCRIBE", {
        id: a
      })
    };
    f.prototype.begin = function (a) {
      var c = a || "tx-" + this.counter++;
      this._transmit("BEGIN", {
        transaction: c
      });
      var e = this;
      return {
        id: c,
        commit: function () {
          return e.commit(c)
        },
        abort: function () {
          return e.abort(c)
        }
      }
    };
    f.prototype.commit = function (a) {
      return this._transmit("COMMIT", {
        transaction: a
      })
    };
    f.prototype.abort = function (a) {
      return this._transmit("ABORT", {
        transaction: a
      })
    };
    f.prototype.ack = function (a, c, f) {
      null == f && (f = {});
      f["message-id"] = a;
      f.subscription = c;
      return this._transmit("ACK", f)
    };
    f.prototype.nack = function (a, c, f) {
      null == f && (f = {});
      f["message-id"] = a;
      f.subscription = c;
      return this._transmit("NACK", f)
    };
    return f
  }();
  var a = {
    VERSIONS: {
      V1_0: "1.0",
      V1_1: "1.1",
      V1_2: "1.2",
      supportedVersions: function () {
        return "1.1,1.0"
      }
    },
    client: function (c, m) {
      null == m && (m = ["v10.stomp", "v11.stomp"]);
      var e =
        new(a.WebSocketClass || WebSocket)(c, m);
      return new h(e)
    },
    over: function (a) {
      return new h(a)
    },
    Frame: c
  };
  "undefined" !== typeof exports && null !== exports && (exports.Stomp = a);
  "undefined" !== typeof window && null !== window ? (a.setInterval = function (a, c) {
    return window.setInterval(c, a)
  }, a.clearInterval = function (a) {
    return window.clearInterval(a)
  }, window.Stomp = a) : exports || (self.Stomp = a)
}).call(this);

let Vonix = function (p, m) {
  // p = p.match("^(https?://)") ? p : "https://" + p;
  // p = "/" == p.substr(-1) ? p.slice(0, -1) : p;
  // var port = "https" == p.substr(0, 5) ? 8011 : 8010;
  var port = 8011;
  var c = null,
    h = {};
  var retry = 0;

  var connect = function (attempt) {
    c = Stomp.over(new SockJS(p + "/stomp"));
    c.heartbeat.outgoing = 25E3;
    c.heartbeat.incoming = 0;
    c.debug = function () {};
    
    console.log("Connecting to " + p + "/stomp", attempt);
    if(attempt <= 20){
      retry = attempt+1;
      c.connect("connector", "txsa56", on_connect, on_connect_error, "/")
    }
  };
  var on_connect = function () {
    c.subscribe("/topic/agent-" + m, on_message);
    "function" === typeof h.onConnect ? h.onConnect(new Date) : void 0
  };
  var on_connect_error = function (a) {
    "function" ===
    typeof h.onError ? h.onError(new Date, "broker", "Connection to " + p + " has been lost") : void 0;
    c.connected || setTimeout(connect(retry), 500)
  };
  var on_message = function (a) {
    a = parse_event(a.body);
    switch (a.event_name) {
      case "dial":
        "function" === typeof h.onDial ? h.onDial(a.id, a.date, a.queue, a.from, a.to, a.callfilename, a.contact_name, a.action_id) : void 0;
        break;
      case "dialconnect":
        "function" === typeof h.onDialAnswer ? h.onDialAnswer(a.id, a.date) : void 0;
        break;
      case "dialfailure":
        "function" === typeof h.onDialFailure ? h.onDialFailure(a.id,
          a.date, a.cause, a.cause_txt) : void 0;
        break;
      case "called":
        "function" === typeof h.onReceive ? h.onReceive(a.id, a.date, a.queue, a.from, a.to, a.callfilename, a.contact_name, a.action_id, a.data) : void 0;
        break;
      case "calledsuccess":
        "function" === typeof h.onReceiveAnswer ? h.onReceiveAnswer(a.id, a.date, a.waiting_seconds) : void 0;
        break;
      case "calledfailure":
        "function" === typeof h.onReceiveFailure ? h.onReceiveFailure(a.id, a.date, a.ringing_seconds) : void 0;
        break;
      case "hangup":
        "function" === typeof h.onHangUp ? h.onHangUp(a.id, a.date,
          a.cause, a.cause_txt) : void 0;
        break;
      case "login":
        "function" === typeof h.onLogin ? h.onLogin(a.date, a.location) : void 0;
        break;
      case "logoff":
        "function" === typeof h.onLogoff ? h.onLogoff(a.date, a.location, a.duration) : void 0;
        break;
      case "pause":
        "function" === typeof h.onPause ? h.onPause(a.date, a.reason) : void 0;
        break;
      case "unpause":
        "function" === typeof h.onUnpause ? h.onUnpause(a.date, a.reason, a.pause_seconds) : void 0;
        break;
      case "agent_status":
        "function" === typeof h.onStatus ? h.onStatus(a.status, a.location, a.since, a.status_data) :
          void 0
    }
  };
  var parse_event = function (a) {
    var c = {};
    if ("undefined" != typeof window.DOMParser) var h = (new window.DOMParser).parseFromString(a, "text/xml").documentElement;
    else "undefined" != typeof window.ActiveXObject && new window.ActiveXObject("Microsoft.XMLDOM") && (h = new window.ActiveXObject("Microsoft.XMLDOM"), h.async = "false", h = h.loadXML(a).documentElement);
    c.event_name = h.attributes.name.nodeValue;
    for (a = 0; a < h.childNodes.length; a++)
      if (1 == h.childNodes[a].nodeType)
        if (1 < h.childNodes[a].childNodes.length) {
          c[h.childNodes[a].tagName] = {};
          for (var e = 0; e < h.childNodes[a].childNodes.length; e++) 1 == h.childNodes[a].childNodes[e].nodeType && h.childNodes[a].childNodes[e].firstChild && (c[h.childNodes[a].tagName][h.childNodes[a].childNodes[e].tagName] = h.childNodes[a].childNodes[e].firstChild.nodeValue)
        } else h.childNodes[a].firstChild && (c[h.childNodes[a].tagName] = "date" == h.childNodes[a].tagName || "since" == h.childNodes[a].tagName ? parse_date(h.childNodes[a].firstChild.nodeValue) : h.childNodes[a].firstChild.nodeValue);
    return c
  };
  var parse_date = function (a) {
    a =
      a.match(/\d+/g);
    return new Date(a[2], a[1] - 1, a[0], a[3], a[4], a[5], 0)
  };
  connect(retry);
  this.onDial = function (a) {
    h.onDial = a
  };
  this.onDialAnswer = function (a) {
    h.onDialAnswer = a
  };
  this.onDialFailure = function (a) {
    h.onDialFailure = a
  };
  this.onReceive = function (a) {
    h.onReceive = a
  };
  this.onReceiveAnswer = function (a) {
    h.onReceiveAnswer = a
  };
  this.onReceiveFailure = function (a) {
    h.onReceiveFailure = a
  };
  this.onHangUp = function (a) {
    h.onHangUp = a
  };
  this.onLogin = function (a) {
    h.onLogin = a
  };
  this.onLogoff = function (a) {
    h.onLogoff = a
  };
  this.onPause = function (a) {
    h.onPause =
      a
  };
  this.onUnpause = function (a) {
    h.onUnpause = a
  };
  this.onStatus = function (a) {
    h.onStatus = a
  };
  this.onConnect = function (a) {
    h.onConnect = a
  };
  this.onError = function (a) {
    h.onError = a
  };
  this.doDial = function (a, f, h, e, p) {
    let xml = '<action name="dial"><id>' + p + "</id><agent>" + m + "</agent><to>" + a + "</to><name>" + f + "</name><queue>" + h + "</queue><billing_group_id>" + e + "</billing_group_id></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doTransfer = function (a, f) {
    let xml = '<action name="transfer"><id>js_' + m + "_1</id><agent>" + m + "</agent><call_id>" +
      a + "</call_id><to>" + f + "</to></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doHangUp = function (a) {
    let xml = '<action name="hangup"><id>js_' + m + "_1</id><agent>" + m + "</agent><call_id>" + a + "</call_id></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doPause = function (a) {
    let xml = '<action name="pause"><id>js_' + m + "_1</id><agent>" + m + "</agent><reason>" + a + "</reason></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doUnpause = function () {
    let xml = '<action name="unpause"><id>js_' + m + "_1</id><agent>" + m + "</agent></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doLogoff = function () {
    let xml = '<action name="logoff"><id>js_' + m + "_1</id><agent>" + m + "</agent></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doTag = function (a, f) {
    let xml = '<action name="tag"><id>js_' + m + "_1</id><call_id>" + a + "</call_id><tag>" + f + "</tag></action>";
    c.send("/queue/actions", {}, xml)
  };
  this.doStatus = function (a) {
    let xml = '<action name="get_agent_status"><id>js_' + m + "_1</id><agent>" + m + "</agent><queue>" + a + "</queue></action>";
    c.send("/queue/actions", {}, xml)
  }
};
const status = {
  'deslogado': 0,
  'disponivel': 1,
  'emPausa': 2,
  'indisponivel': 9
}

export {
  Vonix,
  status
}


// WEBPACK FOOTER //
// ./src/assets/js/vue-vonix-1.6.js